import { render, staticRenderFns } from "./discount-code-customers-show.vue?vue&type=template&id=0a9f3b88"
import script from "./discount-code-customers-show.vue?vue&type=script&lang=js"
export * from "./discount-code-customers-show.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports